import 'twin.macro';
import Card from '@teetsh/app/src/components/Card';
import {
  ArrowDownTrayIcon,
  PencilSquareIcon,
} from '@heroicons/react/24/outline';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import SimpleNarrowPage from 'components/Layouts/SimpleNarrowPage';
import React from 'react';
import { useTranslation } from 'react-i18next';

export function ImportEleves() {
  const navigate = useNavigate();
  const { t } = useTranslation(['eleve']);
  const location = useLocation();

  const { schoolyearId, schoolId } = useParams<{
    schoolyearId: string;
    schoolId: string;
  }>();
  return (
    <div tw="pt-8">
      <SimpleNarrowPage>
        <SimpleNarrowPage.Title>
          {t('eleve:import.optionsTitle')}
        </SimpleNarrowPage.Title>
        <div tw="mb-6 flex flex-col gap-4">
          <Card
            tw="text-center px-4 py-8"
            interactive
            onClick={() => navigate(`${location.pathname}/file`)}
          >
            <div tw="flex flex-col gap-2 items-center">
              <div tw="flex gap-2.5 items-center justify-center w-full">
                <ArrowDownTrayIcon tw="h-6 w-6" />
                <h3 tw="font-bold text-xl text-neutral-intense">
                  {t('eleve:import.uploadAFile')}
                </h3>
              </div>
              <div tw="text-neutral-quiet text-base">
                {t('eleve:import.selectCsvFromYourComputer')}
              </div>
            </div>
          </Card>

          <Card
            tw="text-center px-4 py-8"
            interactive
            onClick={async () => {
              const params = new URLSearchParams(location.search);
              params.set('open', 'true');
              navigate(
                `/annee-scolaire/${schoolyearId}/ecole/${schoolId}/eleves/views?${params.toString()}`,
              );
            }}
          >
            <div tw="flex flex-col gap-2 items-center">
              <div tw="flex gap-2.5 items-center justify-center w-full">
                <PencilSquareIcon tw="h-6 w-6" />
                <h3 tw="font-bold text-xl text-neutral-intense">
                  {t('eleve:import.addManually')}
                </h3>
              </div>
              <div tw="text-neutral-quiet text-base">
                {t('eleve:import.addElevesOneByOne')}
              </div>
            </div>
          </Card>
        </div>
      </SimpleNarrowPage>
    </div>
  );
}
